import { HttpErrorResponse } from '@angular/common/http';

/**
 * Append the backend's request reference (`X-Request-ID`) to an error message,
 * so a user's report can be matched to its log lines in Admin → System logs.
 * Leaves the message alone when the response carries no reference (a network
 * failure, or nginx answering because the app server is down).
 */
export function withErrorRef(message: string, err: HttpErrorResponse): string {
  const ref = err.headers?.get('X-Request-ID');
  return ref ? `${message} (Ref: ${ref})` : message;
}
